import type { Locale } from "../locale";
import { common } from "./common";
import { contracts } from "./contracts";
import { organisation } from "./organisation";
import { users } from "./users";

/**
 * Every area, merged. A screen's area is added here once; after that its keys
 * are part of `MessageKey` and `t` accepts them.
 */
export const MESSAGES = {
  ja: { ...common.ja, ...contracts.ja, ...organisation.ja, ...users.ja },
  en: { ...common.en, ...contracts.en, ...organisation.en, ...users.en },
} as const satisfies Record<Locale, Readonly<Record<string, string>>>;

export type MessageKey = keyof (typeof MESSAGES)["ja"];
